import { render, staticRenderFns } from "./main-block.vue?vue&type=template&id=20bdfabe&"
import script from "./main-block.vue?vue&type=script&lang=js&"
export * from "./main-block.vue?vue&type=script&lang=js&"
import style0 from "./main-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20bdfabe')) {
      api.createRecord('20bdfabe', component.options)
    } else {
      api.reload('20bdfabe', component.options)
    }
    module.hot.accept("./main-block.vue?vue&type=template&id=20bdfabe&", function () {
      api.rerender('20bdfabe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/footer/main-block.vue"
export default component.exports